export default __webpack_public_path__ + "static/media/wrong.c9e041e6.jpg";